export default function getResource(label, vars = []) {
    const resources = {
        estimatedTotal: 'Estimated Total'
    };

    return resources[label];
}
